goog.provide("shadow.js.shim.module$$mui$material$Avatar$default");
shadow.js.shim.module$$mui$material$Avatar$default = shadow.js.shim.module$$mui$material$Avatar.default;
